import React, { useMemo, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import UserInspectionProductDetail from "./UserInspectionProductDetail";
import {
  fromBmarkenDateToDateTime,
  fromBmarkenDateToDay,
  priceText,
} from "../utils/utils";

function safeTime(v) {
  if (!v) return 0;
  const t = new Date(v).getTime();
  return Number.isFinite(t) ? t : 0;
}

const decodeProductStatus = (status) => {
  const s = Number(status);
  switch (s) {
    case 0:
      return "Active";
    case 1:
      return "Inactive";
    case 2:
      return "Expired";
    case 3:
      return "Burned";
    case 4:
      return "Standby";
    case 5:
      return "Deleted";
    default:
      return "-";
  }
};

const isExpiredByDate = (expiration_date) => {
  if (!expiration_date) return false;
  const exp = new Date(expiration_date);
  const expMs = exp.getTime();
  if (!Number.isFinite(expMs)) return false;
  return expMs < Date.now();
};

// Forza Expired SOLO se: status==0 AND scadenza passata
const effectiveStatus = (item) => {
  const raw = Number(item?.status);
  if (raw === 0 && isExpiredByDate(item?.expiration_date)) return 2;
  return raw;
};

const cellStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export default function UserInspectionProducts({
  products,
  onShowTransactions,
  onExpiryDateUpdated, // ✅ nuovo
}) {
  const [filterAttivi, setFilterAttivi] = useState(false);

  const filteredAndSorted = useMemo(() => {
    const list = [...(products || [])];

    const filtered = filterAttivi
      ? list.filter((p) => effectiveStatus(p) === 0)
      : list;

    filtered.sort((a, b) => safeTime(b.created_at) - safeTime(a.created_at));
    return filtered;
  }, [products, filterAttivi]);

  return (
    <div style={{ width: "100%" }}>
      <Box mb={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={filterAttivi}
              onChange={(e) => setFilterAttivi(e.target.checked)}
              color="primary"
            />
          }
          label="Attivi"
        />
      </Box>

      <Box
        display="flex"
        alignItems="center"
        style={{
          padding: "8px 16px",
          borderBottom: "1px solid rgba(0,0,0,0.12)",
        }}
      >
        <Box flex={2} pr={2}>
          <Typography variant="h6">Creato</Typography>
        </Box>
        <Box flex={4} pr={2}>
          <Typography variant="h6">Campagna</Typography>
        </Box>
        <Box flex={2} pr={2} style={{ textAlign: "right" }}>
          <Typography variant="h6">Valore</Typography>
        </Box>
        <Box flex={2} pr={2} style={{ textAlign: "right" }}>
          <Typography variant="h6">Residuo</Typography>
        </Box>
        <Box flex={2} pr={2}>
          <Typography variant="h6">Stato</Typography>
        </Box>
        <Box flex={2} pr={2}>
          <Typography variant="h6">Scadenza</Typography>
        </Box>
        <Box flex={2} pr={2}>
          <Typography variant="h6">Aggiornato</Typography>
        </Box>
        <Box width={40} />
      </Box>

      {filteredAndSorted.map((p, i) => {
        const creato = fromBmarkenDateToDay(p.created_at);
        const campagna = p.campaign_name ?? "-";
        const valore = priceText(p.value);
        const residuo = priceText(p.available_value);
        const stato = decodeProductStatus(effectiveStatus(p));
        const scadenza = fromBmarkenDateToDay(p.expiration_date);
        const aggiornato = fromBmarkenDateToDateTime(p.updated_at);

        return (
          <Accordion key={p.id || i} square>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box display="flex" alignItems="center" width="100%">
                <Box flex={2} pr={2} style={cellStyle}>
                  <Typography>{creato}</Typography>
                </Box>

                <Box flex={4} pr={2} style={cellStyle}>
                  <Typography>{campagna}</Typography>
                </Box>

                <Box
                  flex={2}
                  pr={2}
                  style={{ ...cellStyle, textAlign: "right" }}
                >
                  <Typography>{valore}</Typography>
                </Box>

                <Box
                  flex={2}
                  pr={2}
                  style={{ ...cellStyle, textAlign: "right" }}
                >
                  <Typography>{residuo}</Typography>
                </Box>

                <Box flex={2} pr={2} style={cellStyle}>
                  <Typography>{stato}</Typography>
                </Box>

                <Box flex={2} pr={2} style={cellStyle}>
                  <Typography>{scadenza}</Typography>
                </Box>

                <Box flex={2} pr={2} style={cellStyle}>
                  <Typography>{aggiornato}</Typography>
                </Box>
              </Box>
            </AccordionSummary>

            <AccordionDetails style={{ display: "block" }}>
              <Box pl={4} pr={1} width="100%">
                <UserInspectionProductDetail
                  item={p}
                  onShowTransactions={onShowTransactions}
                  updateExpiryDate={true}
                  onExpiryDateUpdated={onExpiryDateUpdated}
                  canReverseTransaction={true}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
}
